var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBacklogsSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-search-875357",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.15,
    height: 11.166,
    viewBox: "0 0 11.15 11.166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8616",
    "data-name": "Path 8616",
    d: "M198.6,127.8l-2.081-2.062a5.029,5.029,0,0,0-.372-6.67,5.012,5.012,0,0,0-7.079,7.1,5.009,5.009,0,0,0,6.67.372L197.8,128.6a.535.535,0,0,0,.39.167.506.506,0,0,0,.39-.167.578.578,0,0,0,.019-.8Zm-2.081-5.184a3.821,3.821,0,0,1-1.152,2.75,3.93,3.93,0,0,1-2.75,1.152,3.821,3.821,0,0,1-2.75-1.152,3.929,3.929,0,0,1-1.152-2.75,3.82,3.82,0,0,1,1.152-2.75,3.9,3.9,0,0,1,2.75-1.152,3.821,3.821,0,0,1,2.75,1.152A3.9,3.9,0,0,1,196.518,122.618Z",
    transform: "translate(-187.6 -117.602)",
    fill: "#4eb6ee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacklogsSearch);
export default __webpack_public_path__ + "static/media/backlogs-search.016d102ef12cc687483fc09200788329.svg";
export { ForwardRef as ReactComponent };